import { render, staticRenderFns } from "./Chosen.vue?vue&type=template&id=65cb3213&"
import script from "./Chosen.vue?vue&type=script&lang=js&"
export * from "./Chosen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports